import React, { ReactNode } from "react";
import "./ClearProfitStructureCards.css";
import blackShirt from "../../images/HomePage/ClearProfitStructure/blackShirt.png";
import blackTravelMug from "../../images/HomePage/ClearProfitStructure/blackTravelMug.png";
import blackTumbler from "../../images/HomePage/ClearProfitStructure/blackTumbler.png";
import cheddJalapeno from "../../images/HomePage/ClearProfitStructure/cheddarJalapeno.png";
import chocolateAlmonds from "../../images/HomePage/ClearProfitStructure/chocolateAlmonds.png";
import fruityPopcorn from "../../images/HomePage/ClearProfitStructure/fruityPopcorn.png";
import macadamiaCookie from "../../images/HomePage/ClearProfitStructure/macadamiaNutCookie.png";
import redHoodie from "../../images/HomePage/ClearProfitStructure/redHoodie.png";

interface CardProps {
  percentage: string;
  subtitle: string;
  description: string;
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({
  percentage,
  subtitle,
  description,
  children,
}) => (
  <div className="clear-profit-structure-card">
    <h2 className="clear-profit-structure-percentage">{percentage}</h2>
    <p className="clear-profit-structure-subtitle">{subtitle}</p>
    <p className="clear-profit-structure-description">{description}</p>
    <div className="clear-profit-structure-images">{children}</div>
  </div>
);

export const FoodItems = () => {
  return (
    <div className="col-md-6 mb-4">
      <Card
        percentage="50%"
        subtitle="on food items"
        description="Snack sales aren’t just delicious — they deliver real value, with half the proceeds supporting the fundraiser."
      >
        <div className="clear-profit-structure-img-container">
          <img
            src={chocolateAlmonds}
            className="clear-profit-structure-img-chocAlmond"
            alt="Chocolate Almonds"
          />
          <img
            src={fruityPopcorn}
            className="clear-profit-structure-img-fruity-popcorn"
            alt="Fruity Popcorn"
          />
          <img
            src={macadamiaCookie}
            className="clear-profit-structure-img-cookies"
            alt="Macadamia Cookies"
          />
          <img
            src={cheddJalapeno}
            className="clear-profit-structure-img-cheddJal-popcorn"
            alt="Cheddar Jalapeno Popcorn"
          />
        </div>
      </Card>
    </div>
  );
};

export const CustomizedGoods = () => {
  return (
    <div className="col-md-6 mb-4">
      <Card
        percentage="40%"
        subtitle="on customized goods"
        description="A meaningful share of every t-shirt, hoodie, or bottle sold goes right back to your team — no hidden fees."
      >
        <div className="clear-profit-structure-img-container">
          <img
            src={redHoodie}
            className="clear-profit-structure-img-hoodie"
            alt="Hoodie"
          />
          <img
            src={blackShirt}
            className="clear-profit-structure-img-shirt"
            alt="T-shirt"
          />
          <img
            src={blackTravelMug}
            className="clear-profit-structure-img-trvMug"
            alt="Travel Mug"
          />
          <img
            src={blackTumbler}
            className="clear-profit-structure-img-tumbler"
            alt="Tumbler"
          />
        </div>
      </Card>
    </div>
  );
};
